import React from 'react';
import { withTranslation } from 'react-i18next';
import { Alert } from 'reactstrap';
import Loader from './snippets/loader';
import { SettingsContext } from "./context";

class NedarimCardForm extends React.Component {
  static contextType = SettingsContext;

  constructor(props) {
    super(props);
    this.state = {
      loadingIframe: true,
      isSubmitting: false,
      error: null,
      confirmed: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.ReadPostMessage = this.ReadPostMessage.bind(this);
  }

  componentDidMount(){
    if (window.addEventListener) { window.addEventListener("message", this.ReadPostMessage, false); } else { window.attachEvent("onmessage", this.ReadPostMessage); }
    let {settings} = this.props.settings ? this.props : this.context;
    this.setState({apiValid:settings.stripePK.value, mosad: settings.ccProcessorCompanyId.value});
  }

  handleSubmit(ev){
    ev.preventDefault();
    this.props.handleIsLoading(true);
    const { firstName, lastName, paymentAmount } = this.props;
    this.PostNedarim({
        'Name': 'FinishTransaction2',
        'Value': {
            'Mosad': this.state.mosad,
            'ApiValid': this.state.apiValid,
            'PaymentType': 'Ragil',
            'Currency': '1',

            'Zeout': '',
            'FirstName': firstName,
            'LastName': lastName,
            'Street': '',
            'City': '',
            'Phone': '',
            'Mail': '',

            'Amount': paymentAmount,
            'Tashlumim': '1',

            'Groupe': '',
            'Comment': '',

            'Param1': '',
            'Param2': '',
            'ForceUpdateMatching': '1', //מיועד לקמפיין אם מעוניינים שהמידע יידחף ליעד, למרות שזה לא נהוג באייפרם

            'CallBack': '', //מיועד לקבלת WEBHOOK לאחר כל עסקה / סירוב
            'CallBackMailError': '', //מיועד לקבלת התראה על תקלת בשליחת קאלבק למייל של המפתח במקום למייל של אנשי הקשר של המוסד

            'Tokef': '' //אם אתם מנהלים את התוקף בדף שלכם (מיועד למי שרוצה להפריד בין חודש לשנה ורוצה לעצב מותאם אישית)

        }
    });
  }

  ReadPostMessage(event) {
    switch (event.data.Name) {
      case 'Height':
        //Here you get the height of iframe | event.data.Value
        this.setState({loadingIframe: false}, () => document.getElementById('NedarimFrame').style.height = (parseInt(event.data.Value) + 15) + "px")
        break;
        
        case 'TransactionResponse':
            console.log(event.data.Value)
            if (event.data.Value.Status == 'Error') {
              this.setState({transactionError: event.data.Value.Message});
              this.props.handleIsLoading(false);
            } else {
              this.props.onPaymentComplete(event.data.Value);
            }
    }
  }

  PostNedarim(Data) {
    var iframeWin = document.getElementById('NedarimFrame').contentWindow; 
    iframeWin.postMessage(Data, "*");
  };


  render() {
    const { t, formRef, lang } = this.props;
    const { loadingIframe, transactionError } = this.state;
    return <div>
    {transactionError?<Alert color="danger">{t("Transaction Error")}: {t(transactionError)}</Alert>:null} 
    <form ref={formRef} onSubmit={this.handleSubmit} autoComplete="off">
      <div className="dir-ltr">
      {loadingIframe?
        <Loader />
      :
        null
      }
      <iframe id="NedarimFrame" style={{width:'100%',height:'0px',border:'none'}} scrolling="no" src={`https://matara.pro/nedarimplus/iframe?language=${lang}&Picture=Hide`} onLoad={() => this.PostNedarim({'Name':'GetHeight'})}></iframe>
      </div>
    </form>
    </div>
  }
}
export default withTranslation()(NedarimCardForm);